module.exports = __webpack_public_path__ + "static/z16-2-main-slide-123fe3623e81ca1d889c59655f4ebfe5.jpg";